import React from 'react';
import { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../Component/CommonPopup/CommonPopup';
import checkImg from '../../assets/img/check.svg';
import errorImg from '../../assets/img/erroricon.png';
import "../../Component/CommonPopup/commonPopup.css";
import PageNotFound from '../FallBackUI/PageNotFound';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { CountContext } from '../Context/Allcontext';

const Accept = (props) => {
  console.log("===props checkCars====", props.carId, props.buyerId, props.highBid, props.recentlyAddedcheckedCars)
  console.log("checkHighBid", props.carId);
  const { handleTitleCount } = useContext(CountContext) || {};

  const history = useHistory();
  const [userName, setUserName] = useState("");
  const [checkHighBid, setcheckHighBid] = useState(props.highBid);
  const [checkCarlist, setcheckCarlist] = useState(props.carId);
  console.log("checkHighBid12333", checkCarlist);

  const [password, setPassword] = useState("");
  // const { id } = useParams();
  const sellerData = useSelector(state => state.LoginReducer.payload);
  const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");
  // const [userNameError,setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [alertmessage, setAlertMessage] = useState("");
  const [alerttitle, setAlertTitle] = useState("");
  const [alertimg, setAlertImg] = useState("");

  const [errors, setErrors] = useState("");
  const [errorFlag, setErrorFlag] = useState(false);

  const email = sellerData.email;


  const [toggleAcceptPopupOpen, setToggleAcceptPopupOpen] = useState(true);
  const toggleCommonPopup = () => {
    setIsCommonPopupOpen(!isCommonPopupOpen);
  }
  const handleAccepts = () => {
    //setUsernameError("")
    setPasswordError("")

    //  if(!userName){
    //   setUsernameError("Username is required")
    //   return;
    //  }
    // else if(userName && !new RegExp(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i).test(userName)){
    //   setUsernameError("Must match the email format")
    // return;
    //   }
    //   if(!password){
    //     setPasswordError("Password is required")
    //     return;
    //   }
    //   else if(password && !new RegExp(/(^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,}))/).test(password)){
    //     setPasswordError("Password must have minimum of 8 characters with the combination of upper ,lower case letters , number and a special character")
    //     return;
    // }


    let request =
      [{
        seller_dealer_id: sellerData.seller_dealer_id,
        // seller_id:sellerData.seller_id, 
        active: 1,
        car_id: props.carId,
        // email:userName,
        // email:sellerData.email,
        //  password:password,
        buyer_dealer_id: props.buyerId,
        updatedBy: sellerData.seller_id,
        createdBy: sellerData.seller_id,
        buyer_id: props.buyerDealerId,
        status: "sold",
        seller_id: sellerData.seller_id,
        seller_token: sellerData.seller_token,
        price: props.highBid,
        buying_proccess: "seller",
        transportation_charge: props.transportationCharge
      }]

    console.log("accepted Request", request);
    // return
    API.post('accpectedCars/add', request).then(response => {

      console.log("===accepted====", response)
      if (response.data.success) {
        console.log("----accepted---- response=>", response)
        setToggleAcceptPopupOpen(false);
        setAlertImg(checkImg);
        setAlertTitle("Successfully Accepted")
        setAlertMessage("Thank you so much for your business, We thank you to let us earn your business.")
        handleTitleCount();
        props.handleClose1();

      } else {
        const { data } = response;
        setToggleAcceptPopupOpen(false);
        setAlertImg(errorImg);
        console.log("error response=>", data.error.err)
        setAlertMessage(data.error.err)

      }

    })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.error)
          setErrorFlag(true)

        }
      });
  }
  const handleOkClick = () => {
    props.toggle();
    props.onSuccess?.();
  };
  return (

    <div>
      <div id="" className="saveSearchBlock acceptConfirmation">
        {errorFlag === true ? <PageNotFound error={errors} /> :
          <div className="termspageblock">
            <div className="row content">
              {toggleAcceptPopupOpen ?
                (<Modal show={true} onHide={props.toggle} centered >
                  <Modal.Header className='Terms-login'>
                    <h2 className="title"> Accept confirmation </h2>
                  </Modal.Header>
                  {checkHighBid.length > 0 || checkCarlist.length > 0 ?
                    <div class="col-md-12 text-center mb-3">

                      Are you sure,If you want to accept please confirm
                    </div> :

                    <div class="col-md-12 text-center mb-3">
                      Cars Should be Selected before Accept
                    </div>}

                  <div class="Sellernotes">
                    <button className="cta-btns" onClick={props.toggle}>Cancel</button>
                    {checkHighBid.length > 0 || checkCarlist.length > 0 ?
                      <button className="cta-btns" onClick={handleAccepts}>Accept</button> :
                      <button className="cta-btns1" type="button" disabled>Accept</button>}
                  </div>
                </Modal>) :
                (

                  <Modal show={true} onHide={props.toggle} centered >
                    <Modal.Header className='Terms-login'>
                      <h2 className="title"> {alerttitle} </h2>
                    </Modal.Header>

                    <div className='acceptedcarsus'>
                      <img alt="" className={alertimg === checkImg ? "successImg " : "errorImg"} src={alertimg}></img>
                    </div>
                    <div class="col-md-12 text-center">
                      <p class="text-center">{alertmessage}</p>
                    </div>

                    <div class="Sellernotes">
                      <button className="cta-btns" onClick={handleOkClick}>ok</button>
                    </div>
                  </Modal>
                )}

            </div>
          </div>}
      </div>

      {isCommonPopupOpen && <CommonPopup
        handleClose={isCommonPopupOpen}
        popupTitle={popupTitle}
        popupMsg={popupMsg}
        popupType={popupType}
        popupActionType={popupActionType}
        popupActionValue={popupActionValue}
        popupActionPath={popupActionPath}
      />}
    </div>
  )
}

export default Accept;